export const tableTitles = {
  taxAuthorityAssets: 'רשות המיסים',
  firmAssets: 'מאגר דוחות המשרד',
  sharedAssets: 'מאגר דוחות שיתופי',
  surveyAssets: 'סקר נתוני היצע',
}
